import Router from 'vue-router';
import bus from '@/bus/app-bus';
import configurationRoute from '@/router/configuration';
import login from './login';
import polls from './polls';
import diagnosis from './diagnosis';
import jobevalution from '../modules/job-evaluation/router';
import evaluation360 from '../modules/evaluation-360/router';
import jobProfile from '../modules/job-profile/router';
import user from './user';
import awardsRoute from './awards';
import ThreeSixtyEvaluationRouter from '../modules/three-sixty-evaluation/router';
import recruitmentRoute from '../modules/recruitment/router';
// import professionaProfile from './profiles';

export default function (Vue) {
	Vue.use(Router);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				name: 'page-home',
				component: () => import('@/pages/page-home'),
				redirect: 'working-environment',
				meta: {
					title: 'Clima Laboral',
				},
				children: [
					{
						name: 'working-environment',
						path: 'working-environment',
						component: () => import('@/pages/working-environment/page-working-environment'),
						redirect: 'working-environment/surveys',
						meta: {
							title: 'Clima Laboral',
						},
						props: true,
						children: [
							{
								name: 'working-environment-surveys',
								path: 'surveys',
								component: () => import('@/pages/working-environment/page-surveys'),
								meta: {
									title: 'Clima Laboral',
								},
								children: [
									{
										name: 'working-environment-surveys-new',
										path: 'new',
										component: () => import('@/pages/working-environment/page-surveys-new'),
										meta: {
											title: 'Clima Laboral',
										},
									},
								],
							},
						],
					},
					{
						name: 'organizational-diagnosis',
						path: 'organizational',
						component: () => import('@/pages/organizational/page-organizational'),
						meta: {
							title: 'Diagnóstico Organizacional Praktiko',
						},
						props: true,
						children: [
							{
								name: 'surveys-organizational-diagnosis',
								path: 'surveys',
								component: () => import('@/pages/organizational/page-surveys'),
								meta: {
									title: 'Diagnóstico Organizacional Praktiko',
								},
							},
							{
								name: 'new-organizational-diagnosis',
								path: 'new',
								component: () => import('@/pages/organizational/page-new-surveys'),
								meta: {
									title: 'Diagnóstico Organizacional Praktiko',
								},
							},
						],
					},
					{
						name: 'culture-inventory',
						path: 'inventory',
						component: () => import('@/pages/inventory/page-inventory'),
						meta: {
							title: 'Inventario de Cultura Organizacional',
						},
						props: true,
						children: [
							{
								name: 'surveys-inventory',
								path: 'surveys',
								component: () => import('@/pages/inventory/page-surveys-inventory'),
								meta: {
									title: 'Inventario de Cultura Organizacional',
								},
							},
							{
								name: 'new-inventory',
								path: 'new-surveys',
								component: () => import('@/pages/inventory/page-new-surveys-inventory'),
								meta: {
									title: 'Inventario de Cultura Organizacional',
								},
							},
						],
					},
					diagnosis,
					polls,
					configurationRoute,
					evaluation360,
					jobevalution,
					jobProfile,
					user,
					awardsRoute,
					ThreeSixtyEvaluationRouter,
					recruitmentRoute,
					// professionaProfile,
				],
			},
			{
				path: '/reset-password',
				name: 'reset-password',
				meta: {
					title: 'Recuperar Contraseña',
				},
				component: () => import('@/pages/page-reset-password'),
			},
			{
				path: '/applications-form/:id/:code/:idCompany',
				name: 'applications-form',
				meta: {
					title: 'Postulaciones',
				},
				component: () => import('@/pages/page-applications'),
			},
			{
				name: 'create-profile-applicants',
				path: '/create-profile-applicants/:id/:temporaryToken',
				meta: {
					title: 'Crear Perfil',
				},
				component: () => import('@/components/professional-profile/create-profile'),
			},
			login,
		],
	});
	config.beforeEach((to, from, next) => {
		if (to.name !== 'login') {
			const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
			if (token || to.name === 'reset-password' || to.name === 'applications-form' ||
				to.name === 'create-profile-applicants'
			) {
				return next();
			}
			if (to.name.startsWith('applications-form')) {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});

	// Safety net: every navigation hides the loader so it can never get stuck.
	const LOADER_EVENT = 'app-event-loader-toggle-view';
	config.afterEach(() => {
		bus.$emit(LOADER_EVENT, { show: false });
	});

	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js